import { ReactComponent as SimSalesIcon } from '../../../../../assets/icons/Navegation/ventas-sim.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const IFTReportsMenu = ({
  userPermissions,
  openMenuReportsIft,
  handleClickReportsIft,
  activeStyle,
  drawerOpen,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('IFT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='IFT_REPORTS'
          to='/reports/ift'
          title='Reporte IFT'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('IFT_REPORTS') && (
        <>
          <GenericListItemButton
            onClick={drawerOpen ? handleClickReportsIft : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='IFT'
            IconComponent={(props) => <SimSalesIcon style={icons} {...props} />}
            openMenu={openMenuReportsIft}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuReportsIft}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default IFTReportsMenu;
